import { render } from "./Boosts.vue?vue&type=template&id=c2b2a964&ts=true"
import script from "./Boosts.vue?vue&type=script&lang=ts"
export * from "./Boosts.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__